import { __assign } from "tslib";
import { app } from '@ekuaibao/whispered';
import { getUserQueryField } from '../../utilFn';
export var searchOptionTitle = function (prefix) {
    if (prefix === void 0) { prefix = 'flowId.form'; }
    return {
        key: 'title',
        label: i18n.get('标题'),
        placeholder: i18n.get('请输入要搜索的标题'),
        type: 'text',
        format: function (value) {
            if (!value) {
                return '';
            }
            return prefix + ".title.containsIgnoreCase(\"" + value + "\")";
        }
    };
};
export var searchOptionCode = function (prefix, label, options) {
    if (prefix === void 0) { prefix = 'flowId.form'; }
    if (label === void 0) { label = i18n.get('单号'); }
    return __assign({ key: 'code', label: label, type: 'text', placeholder: i18n.get('请输入要搜索的{__k0}', { __k0: label }), format: function (value) {
            if (!value) {
                return '';
            }
            return prefix + ".code.containsIgnoreCase(\"" + value + "\")";
        } }, options);
};
export var searchOptionSubmitter = function (prefix) {
    if (prefix === void 0) { prefix = 'flowId.form'; }
    return {
        key: 'submitter',
        label: i18n.get('提交人'),
        type: 'staff',
        placeholder: i18n.get('请输入要搜索的提交人'),
        format: function (value) {
            if (!(value === null || value === void 0 ? void 0 : value.length)) {
                return '';
            }
            var str = value.map(function (item) { return "\"" + item + "\""; }).join(',');
            return prefix + ".submitterId.id.in(" + str + ")";
        }
    };
};
export var searchOptionFeeName = function (prefix) {
    if (prefix === void 0) { prefix = 'form'; }
    return {
        key: 'feeName',
        label: i18n.get('费用明细'),
        type: 'text',
        style: {
            width: 100
        },
        placeholder: i18n.get('请输入要搜索的费用明细'),
        format: function (value) {
            if (!(value === null || value === void 0 ? void 0 : value.length)) {
                return '';
            }
            return prefix + ".feeTypeId.name.containsIgnoreCase(\"" + value + "\")";
        }
    };
};
export var searchOptionPayee = function () {
    return {
        key: 'feeName',
        label: i18n.get('收款信息'),
        type: 'text',
        style: {
            width: 100
        },
        placeholder: i18n.get('请输入要搜索的收款信息'),
        format: function (value) {
            if (!(value === null || value === void 0 ? void 0 : value.length)) {
                return '';
            }
            return "payeeId.name.containsIgnoreCase(\"" + value + "\")";
        }
    };
};
export var searchOptionPayNote = function (prefix) {
    if (prefix === void 0) { prefix = 'form'; }
    return {
        key: 'payNote',
        label: i18n.get('支付概要'),
        type: 'text',
        style: {
            width: 100
        },
        placeholder: i18n.get('请输入要搜索的支付概要'),
        format: function (value) {
            if (!(value === null || value === void 0 ? void 0 : value.length)) {
                return '';
            }
            return prefix + ".E_system_paymentPlan_\u652F\u4ED8\u6982\u8981.containsIgnoreCase(\"" + value + "\")";
        }
    };
};
export var searchOptionGlobal = function (prefix) {
    if (prefix === void 0) { prefix = 'flowId.form'; }
    return {
        key: 'global',
        label: i18n.get('文本/数字'),
        type: 'text',
        style: {
            width: i18n.currentLocale === 'zh-CN' ? 110 : 130
        },
        placeholder: i18n.get('请输入文本/数字类信息'),
        format: function (value) {
            if (!value) {
                return '';
            }
            return "(" + prefix + ".title.containsIgnoreCase(\"" + value + "\") || " + prefix + ".code.containsIgnoreCase(\"" + value + "\") || " + prefix + ".containsIgnoreCase(\"" + value + "\"))";
        }
    };
};
export var searchOptionTitleAndCode = function (prefix, options) {
    var _a, _b;
    if (prefix === void 0) { prefix = 'flowId.form'; }
    if (options === void 0) { options = {}; }
    return {
        key: 'title',
        label: (_a = options.label) !== null && _a !== void 0 ? _a : i18n.get('标题/单号'),
        placeholder: (_b = options.placeholder) !== null && _b !== void 0 ? _b : i18n.get('请输入要搜索的标题/单号'),
        type: 'text',
        style: {
            width: 112
        },
        format: function (value) {
            var _a, _b;
            if (!value) {
                return '';
            }
            return ((_a = options.titlePrefix) !== null && _a !== void 0 ? _a : prefix) + ".title.containsIgnoreCase(\"" + value + "\") || " + ((_b = options.codePrefix) !== null && _b !== void 0 ? _b : prefix) + ".code.containsIgnoreCase(\"" + value + "\")";
        }
    };
};
export var searchAll = function (prefix) {
    if (prefix === void 0) { prefix = 'flowId.form'; }
    var userQueryField = getUserQueryField();
    return {
        key: 'searchTitleCodeSubmitter',
        label: i18n.get('全部'),
        placeholder: i18n.get('搜索标题、单号或提交人'),
        type: 'text',
        style: {
            width: 110
        },
        format: function (value) {
            if (!value) {
                return '';
            }
            return "(" + prefix + ".title.containsIgnoreCase(\"" + value + "\") || " + prefix + ".code.containsIgnoreCase(\"" + value + "\") || " + prefix + ".submitterId." + userQueryField + ".containsIgnoreCase(\"" + value + "\"))";
        }
    };
};
export var searchAllGlobal = function (prefix) {
    if (prefix === void 0) { prefix = 'flowId.form'; }
    var userQueryField = getUserQueryField();
    return {
        key: 'searchAllGlobal',
        label: i18n.get('全部'),
        placeholder: i18n.get('搜索文本、数字或提交人'),
        type: 'text',
        style: {
            width: 110
        },
        format: function (value) {
            if (!value) {
                return '';
            }
            return "(" + prefix + ".title.containsIgnoreCase(\"" + value + "\") || " + prefix + ".code.containsIgnoreCase(\"" + value + "\") || " + prefix + ".submitterId." + userQueryField + ".containsIgnoreCase(\"" + value + "\") || " + prefix + ".containsIgnoreCase(\"" + value + "\"))";
        }
    };
};
export var searchOptions = function (prefix, options) {
    if (prefix === void 0) { prefix = 'flowId.form'; }
    if (options === void 0) { options = {}; }
    if (window.isInWeComISV) {
        return [searchOptionTitleAndCode(prefix, options)];
    }
    var SEARCH_ALL = (app.getState()['@common'].powers || {}).SEARCH_ALL;
    if (SEARCH_ALL) {
        return [searchAll(prefix), searchOptionTitleAndCode(prefix, options), searchOptionSubmitter(prefix)];
    }
    return [searchOptionTitleAndCode(prefix, options), searchOptionSubmitter(prefix)];
};
export var globalSearchOptions = function (prefix) {
    if (prefix === void 0) { prefix = 'flowId.form'; }
    if (window.isInWeComISV) {
        return [searchOptionGlobal(prefix)];
    }
    var SEARCH_ALL = (app.getState()['@common'].powers || {}).SEARCH_ALL;
    if (SEARCH_ALL) {
        return [searchAllGlobal(prefix), searchOptionGlobal(prefix), searchOptionSubmitter(prefix)];
    }
    return [searchOptionGlobal(prefix), searchOptionSubmitter(prefix)];
};
